export const BASE_URL = "http://localhost:3000"